export function getMainDomain (url: string | URL): string {
  const urlObject = url instanceof URL 
    ? url 
    : new URL(url || window.location.href);
  
  const { hostname, port, protocol } = urlObject;
  
  if (hostname.includes('localhost')) {
    return `${protocol}//${port ? `localhost:${port}` : 'localhost'}`;
  }
  
  const hostParts = hostname.split('.');
  
  if (hostParts.every(part => !isNaN(part))) {
    return `${protocol}//${port ? `${hostname}:${port}` : hostname}`;
  }
  
  const mainDomain = hostParts.slice(-2).join('.');
  
  const isDefaultPort = (protocol === 'https:' && port === '443') || 
                       (protocol === 'http:' && port === '80');
  
  const host = port && !isDefaultPort ? `${mainDomain}:${port}` : mainDomain;

  return `${protocol}//${host}`;
};